'use client';

import React, { useState, useCallback, useEffect } from 'react'

import { APIError, useAxios } from '../core/_axios';
import { removeServiceFromIpadByUniqueIdentifier } from '../core/_requests';
import { Ipad } from '../core/_models';
import useLocalizedCopy from '../hooks/useLocalizedCopy';

export default function ModalEndServiceOnIpad({
    active: modalIsOpen,
    setActive: setModalIsOpen,
    iPad,
    setIpad
}: {
    active: boolean,
    setActive: (active: boolean) => void,
    iPad: Ipad,
    setIpad: (ipad: Ipad) => void
}) {
    const axios = useAxios();
    const { copy } = useLocalizedCopy();

    const [endingService, setEndingService] = useState(false);
    const [errorEndingService, setErrorEndingService] = useState<string | null>(null);

    const onFormSubmit = useCallback(async (event: React.FormEvent<HTMLFormElement>) => {
        event.preventDefault();
        if (endingService) {
            return;
        }
        setErrorEndingService(null);
        setEndingService(true);
        try {
            const resultingiPad = await removeServiceFromIpadByUniqueIdentifier(axios, iPad.unique_identifier);
            setIpad(resultingiPad);
            setModalIsOpen(false);
        } catch (exception) {
            console.error(exception)
            const errorMessage = exception instanceof APIError ? exception.message : copy.Common.messages.errorOccurred
            setErrorEndingService(errorMessage)
            setEndingService(false)
        }
    }, [endingService, axios, iPad.unique_identifier, setIpad, setModalIsOpen]);

    useEffect(() => {
        if (!modalIsOpen) {
            setErrorEndingService(null);
            setEndingService(false);
        }
    }, [modalIsOpen]);

    return (
        <div>
            <>
                {modalIsOpen ? (
                    <>
                        <div
                            className="justify-center items-center flex overflow-x-hidden overflow-y-auto fixed inset-0 z-50 outline-none focus:outline-none text-left"
                        >
                            <form className="relative w-auto my-6 mx-auto max-w-3xl" onSubmit={onFormSubmit}>
                                {/*content*/}
                                <div className="border-0 rounded-lg shadow-lg relative flex flex-col w-full bg-white outline-none focus:outline-none">
                                    {/*header*/}
                                    <div className="flex items-start justify-between p-5 border-b border-solid border-blueGray-200 rounded-t">
                                        <h3 className="text-xl font-semibold">
                                            {copy.IPads.manage.endService}
                                        </h3>
                                    </div>
                                    {/*body*/}
                                    <div className="relative p-6 flex-auto">
                                        <div className="max-h-[50vh] min-w-[600px] overflow-y-auto overflow-x-hidden">
                                            <div className="grid gap-7.5">
                                                <div className="flex flex-col gap-4">
                                                    <p>
                                                        {copy.Services.list.confirmEnd}
                                                    </p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    {/*footer*/}
                                    <div className="flex items-center justify-end p-6 border-t border-solid border-blueGray-200 rounded-b">
                                        <div className='flex-grow'>
                                            {errorEndingService && <div className="text-red-500 text-sm font-medium">{errorEndingService}</div>}
                                        </div>
                                        <button
                                            className="btn btn-sm btn-light me-2"
                                            type="button"
                                            onClick={() => {
                                                setModalIsOpen(false)
                                            }}
                                        >
                                            {copy.Common.buttons.cancel}
                                        </button>
                                        <button
                                            className="btn btn-sm btn-danger"
                                            type="submit"
                                            disabled={endingService}
                                        >
                                            {!endingService ? copy.IPads.manage.endService : copy.Common.labels.processing + '...'}
                                        </button>
                                    </div>
                                </div>
                            </form>
                        </div>
                        <div className="opacity-25 fixed inset-0 z-40 bg-black"></div>
                    </>
                ) : null}
            </>
        </div>
    )
}